var render = function render(){var _vm=this,_c=_vm._self._c;return _c('eg-b-button',{staticClass:"new-rubric-button",style:({
    flexDirection: _vm.horizontal ? 'row' : 'column',
  }),attrs:{"pressed":_vm.pressed},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default"),_vm._v(" "+_vm._s(_vm.label)+" ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }